import React, { useEffect, useState } from "react";
import { Button, Col, Modal } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import ServiceAdmin from "./AdminService/ServiceAdmin";
import Switch from "@material-ui/core/Switch";
import ModalUpAdmin from "./modalupAdmin";
import "./admin.css";
import Navbar from "../Member/Navbar/Navbar";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";

const Members = (props) => {
  //const [id, setId] = useState("");

  useEffect(() => {
    //setId(JSON.parse(sessionStorage.getItem("user")).id);
    getAdmins();
  }, []);

  //const [adminStatus, setAdminStatus] = useState(false);

  // const handleChange = (event) => {
  //   //setAdminStatus({ ...state, [event.target.name]: event.target.checked });
  //   setAdminStatus({ [event.target.name]: !event.target.checked });
  // };

  const [infos, setInfos] = useState([]);

  // get admin list
  const getAdmins = () => {
    ServiceAdmin.getAllAdmin().then((res) => {
      setInfos(res.data);
    });
  };

  // delete admin by id
  const deleteAmdinById = (id) => {
    ServiceAdmin.deleteAmdin(id).then((res) => {
      setInfos(infos.filter((x) => x.id !== id));
      setShow(false);
    });
  };

  // Update admin infos

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      &thinsp; De {from} à {to} sur {size} Utilisateurs
    </span>
  );
  const { SearchBar } = Search;
  const options = {
    paginationSize: 4,
    pageStartIndex: 0,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,

    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "25",
        value: 25,
      },
      {
        text: "Plus",
        value: infos.length,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
  };

  const defaultSorted = [
    {
      dataField: "name",
      dataField: "id",
      dataField: "price",
      order: "desc",
    },
  ];

  // Implement startWith instead of contain
  function customMatchFunc({ searchText, value, column, row }) {
    if (typeof value !== "undefined") {
      return value.startsWith(searchText);
    }
    return false;
  }
  const columns = [
    {
      dataField: "Utilisateur",
      text: "Utilisateur",
      headerAlign: "center",
      align: "center",
      sort: true,
    },
    {
      dataField: "Email",
      text: "Email",
      headerAlign: "center",
      align: "center",
      sort: true,
    },
    {
      dataField: "Tel",
      text: "Telephone",
      headerAlign: "center",
      align: "center",
      sort: true,
    },
    {
      dataField: "Fonction",
      text: "Fonction",
      headerAlign: "center",
      align: "center",
      sort: true,
    },
    {
      dataField: "Role",
      text: "Role",
      headerAlign: "center",
      align: "center",
      sort: true,
    },
    {
      dataField: "action",
      text: "Actions",
      headerAlign: "center",
      align: "center",
      sort: true,
    },
  ];

  // modal update admin
  const [showAdmin, setShowAdmin] = useState(false);
  const [adminId, setAdminId] = useState();
  const [show, setShow] = useState(false);
  const HandleShow = (id) => {
    setAdminId(id);
    setShowAdmin(true);
  };
  const ToggleAdmin = () => {
    setShowAdmin(false);
  };
  const Toggle = () => {
    setShow(false);
  };
  // const test = [...infos];
  // console.log(infos, "this is ... infos", test);
  const toggleStatus = (id, enabled) => {
    ServiceAdmin.changeStatus(id);
    const newData = [...infos];

    const foundedUserIndex = infos.findIndex((item) => item.id === id);

    newData[foundedUserIndex].enabled = !enabled;
    setInfos(newData);
    // console.log(id);
  };

  const infouser = [];
  const keys = [];
  infos.map((info, i) => {
    keys.push(i);
    infouser.push({
      Utilisateur: `${info.firstName} ${info.lastName}`,
      Email: info.email,
      Tel: info.tel,
      Fonction: info.speciality ? info.speciality.designation : "-",
      Role: info.role,
      action: [
        info.role !== "SUPER_ADMIN" ? (
          <>
            <Switch
              checked={info.enabled}
              onChange={() => {
                toggleStatus(info.id, info.enabled);
              }}
              color="primary"
              name="checked"
              inputProps={{ "aria-label": "primary checkbox" }}
            />
            <Button
              className="mr-2 ml-2 print"
              variant="info"
              onClick={() => {
                HandleShow(info.id);
              }}
            >
              <EditIcon />
            </Button>
            <Button
              className="mr-2"
              variant="danger"
              onClick={() => {
                setAdminId(info.id);
                setShow(true);
              }}
            >
              <DeleteIcon />
            </Button>
          </>
        ) : (
          ""
        ),
      ],
    });
  });

  //console.log("enabled ", !infos[0].enabled, infos[0].role);

  return (
    <>
      <Navbar />
      <div className="container data">
        <ModalUpAdmin
          showAdmin={showAdmin}
          toggleAdmin={ToggleAdmin}
          idAdmin={adminId}
          infos={infos}
        />
        <Modal show={show} onHide={Toggle}>
          <Modal.Body>
            <img
              alt="close modal"
              src="https://img.icons8.com/fluent/48/000000/close-window.png"
              style={{ float: "right" }}
              onClick={Toggle}
            />
            <h6
              style={{
                marginTop: "27px",
                marginBottom: "18px",
                textAlign: "center",
              }}
            >
              Êtes-vous sûr d'annuler ce compte ?
            </h6>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="info" onClick={() => deleteAmdinById(adminId)}>
              Oui
            </Button>

            <Button className="mr-auto" variant="danger" onClick={Toggle}>
              Non
            </Button>
          </Modal.Footer>
        </Modal>
        <h3
          style={{
            borderRadius: "0.25em",
            textAlign: "center",
            border: "1px solid purple",
            padding: "0.5em",
            marginTop: "10px",
          }}
        >
          Liste des utilisateurs
        </h3>

        <Col xs={12}>
          <ToolkitProvider
            keyField="id"
            data={infouser}
            columns={columns}
            search={{ customMatchFunc }}
          >
            {(props) => (
              <div>
                <SearchBar {...props.searchProps} />

                <BootstrapTable
                  striped
                  {...props.baseProps}
                  defaultSorted={defaultSorted}
                  pagination={paginationFactory(options)}
                />
              </div>
            )}
          </ToolkitProvider>
        </Col>
      </div>
    </>
  );
};

export default Members;
